module.exports = __webpack_public_path__ + "static/media/thermometer-full.b1574325.svg";